import Vue from 'vue'
import LegacyWrapperComponent from '@/components/LegacyWrapper'
import { converToCamelCase } from '@/core/util'

/* global
  __application_session__
  __application_version__
  __application_authenticated__
  __application_legacy_base__
  __application_legacy_images__
  __application_legacy_scripts__
  __application_legacy_styles__
  __application_legacy_date_format__
  __application_legacy_time_format__
  __application_legacy_phone_format__
  __application_csrf_token__
  __application_webtrac_app__
*/
export default {

  initialized: false,
  vm_id: 0,
  domSyncEvent: null,
  domSyncElements: [],

  // Initialize the legacy framework, most of this is copied from the js/WebTrac/config.js which is 
  // taken out so that the processes are completely separate and do not affect each other.
  init( ) {
    const requiredFiles = [ 
      "shared/plugins.js", 
      "control.js", 
      "model.js", 
      "view.js",

      // Load views
      "WebTrac/view/webaddtocart.js",
      "WebTrac/view/webcart.js",
      "WebTrac/view/webcheckout.js",		
      "WebTrac/view/webdonation.js",
      "WebTrac/view/webhousehold.js",		
      "WebTrac/view/websearch.js",
      "WebTrac/view/webiteminfo.js",
      "WebTrac/view/webteams.js",
      "WebTrac/view/webschedule.js",		
      "WebTrac/view/webhistory.js",		
      "WebTrac/view/webautodebit.js",
      "WebTrac/view/webbillingupdate.js",
      "WebTrac/view/webmemberships.js",	
      "WebTrac/view/webform.js",
      
      // Load models
      "WebTrac/model/multiselect.js",
      "WebTrac/model/share.js",
      "WebTrac/model/subtypes.js",
      "WebTrac/model/wishlist.js",
      "WebTrac/model/comments.js",      
    ]

    if ( !App ) {
      alert("Unable to load WebTrac framework")
      return
    }
    
    // already initialized no need to continue
    if ( this.initialized ) {
      return
    }
    
    // Set the flag so we know not to load the config that this file will do all the
    // Legacy framework setup.
    App.loadConfig = false;
    
    // Set default Application settings (Taken from config.js)
    $.extend(App.settings, {  
      Product: "WebTrac",    
      Version: __application_version__,
      SessionID: __application_session__,
      BaseHref: __application_legacy_base__,
      ImagePath: __application_legacy_images__,
      ScriptPath: __application_legacy_scripts__,
      StylePath: __application_legacy_styles__,
      LoggedIn: __application_authenticated__,
      DateFormat: __application_legacy_date_format__,
      TimeFormat: __application_legacy_time_format__,
      PhoneFormat: __application_legacy_phone_format__,
      ScriptVersion: __application_version__,
      CSRFToken: __application_csrf_token__,
      WebTracApp: __application_webtrac_app__,
      DebugLevel: 0,     
      NextGen: true
    })
    
    // Set a global class that this is the WebTrac App
		if (__application_webtrac_app__) {
			$("body").addClass("webtrac-app");
		}

    // Set the default localization
    App.localization("en-us");

    App.define("nextgen.components", [], ($parent) => {
      this.createComponents($parent)
    })

    // Initialization Event
    App.define("init", requiredFiles, function( ){
      App.run("view.common.apply", $("body"));		
    });

    // Initialize the application
    App.init();

    // Create legacy components
    this.initializeDomSync()  

    // Scroll to the top of the page
    setTimeout(function () {
      window.scrollTo(0, 1);
    }, 1000);

    // Create the nextgen overlay component
    this.createOverlay();

    // Flag that legacy code has been initialized
    this.initialized = true
    return true;
  },

  createComponents( $parent ) {
    this.createCombobox( $parent )
    this.createCheckbox( $parent )  
    this.createDatepicker( $parent )
    this.createTimePicker( $parent )
    this.createMobileMenu( $parent )
    this.createSocialLinks( $parent )
    this.createFileUpload( $parent )
    this.createMultipleFileUpload( $parent )
    this.createThreads( $parent )
    this.createThreadMessages( $parent )
    this.createSignature( $parent )
  },

  createSocialLinks( $parent ) {
    this.queryComponent($parent, "div[data-component='social-links']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "social-links", "social-links-component", ( component ) => {
        component.props.value = this.getValue($element)
        component.props.facebookLink = $element.attr("data-facebook-link")
        component.props.twitterLink = $element.attr("data-twitter-link")
        component.props.linkedinLink = $element.attr("data-linkedin-link")
        component.props.youtubeLink = $element.attr("data-youtube-link")
        component.props.instagramLink = $element.attr("data-instagram-link")
        return component      
      })
    })
    return true
  },
  
  createMobileMenu( $parent ) {
    this.queryComponent($parent, ".mobile-menu[data-component='mobile-menu']", ( el ) => {
      this.createComponent(el, "menu-button", "menu-button-component", null)
    })
    return true
  },

  createFileUpload( $parent ) {
    this.queryComponent($parent, ".fileupload", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "fileupload", "file-upload-component", ( component ) => {
        component.props.value = new Blob([this.getValue($element)]);
        component.props.name = $element.attr("name");
        component.props.blobFileName = $element.attr("blobfilename");
        component.props.uploadAllowedExtensions = $element.attr("uploadallowedextensions");
        component.props.maxSize = parseInt($element.attr("maxsize"));
        component.props.required = $element.attr("data-rule-required");
        component.props.thumbImage = $element.attr("thumbImage");
        component.props.baseHref = $element.attr(App.settings.BaseHref);
        
        if ($element.attr("allowupdate") === 'true')
          component.props.allowUpdate = true;
        else 
          component.props.allowUpdate = false;

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)    
        }
                
        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }

        return component;      
      })
    })
    return true
  },

  createMultipleFileUpload( $parent ) {
    this.queryComponent($parent, ".multiplefileupload", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "multiplefileupload", "multiple-file-upload-component", ( component ) => {
        component.props.value = new Blob([this.getValue($element)]);
        component.props.name = $element.attr("name");
        component.props.blobFileName = $element.attr("blobfilename");
        component.props.uploadAllowedExtensions = $element.attr("uploadallowedextensions");
        component.props.maxSize = parseInt($element.attr("maxsize"));
        component.props.required = $element.attr("data-rule-required");
        component.props.thumbImage = $element.attr("thumbImage");
        component.props.baseHref = $element.attr(App.settings.BaseHref);

        if ($element.attr("allowupdate") === 'true')
          component.props.allowUpdate = true;
        else
          component.props.allowUpdate = false;

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)
        }

        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }

        return component;
      })
    })
    return true
  },
  
  createThreads( $parent ) {
    this.queryComponent($parent, ".group[data-component='threads']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "threads", "threads-component", ( component ) => {
        component.props.threadHouseholdId = parseInt($element.attr("data-householdid"));
                
        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }

        return component;      
      })
    })
    return true
  },
  
  createThreadMessages( $parent ) {
    this.queryComponent($parent, ".group[data-component='threadmessages']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "threadmessages", "thread-messages-component", ( component ) => {
        component.props.messageThreadIndex = parseInt($element.attr("data-threadid"));
                
        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }

        return component;      
      })
    })
    return true
  },
  
  createDatepicker( $parent ) {
    this.queryComponent($parent, ".date[data-component='datepicker']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "datepicker", "datepicker-component", ( component ) => {
        component.props.value = this.getValue($element)

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)    
        }       
        
        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }

        return component      
      })
      
      this.addDomSyncElement( $element, "datepicker", ( props ) => {
        instance.$props.props.value = props.value
        instance.$props.props.error = props.error
        instance.$props.props.disabled = props.disabled
        instance.$props.props.minDate = props.minDate
        instance.$props.props.maxDate = props.maxDate                  
      })
    })
    return true
  },

  createSignature( $parent ) {
    this.queryComponent($parent, "[data-component='signature']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "signature", "signature-component", ( component ) => {
        component.props.value = this.getValue($element)
        component.props.name = $element.attr("name");
        component.props.disabled = $element.attr("disabled");
        component.props.required = $element.attr("data-rule-required");
        component.props.savedSignature = $element.attr("signatureimage");
        
        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)    
        }   
        
        component.events.change = ( value ) => {
          $element.val(value).trigger("change")
        }
        return component      
      })

      this.addDomSyncElement( $element, "signature", ( props ) => {
        instance.$props.props.value = props.value
        instance.$props.props.error = props.error
        instance.$props.props.disabled = props.disabled                    
      })
    })
    return true
  },
 
  createCheckbox( $parent ) {
    this.queryComponent($parent, ".checkbox[data-component='checkbox']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "checkbox", "checkbox-component", ( component ) => {
        component.props.value = this.getValue($element)

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)    
        }       
        
        // Change event to update base element with value changes
        component.events.change = ( checked ) => {
          $element.prop("checked", checked).trigger("change")
        }

        return component      
      })
      
      this.addDomSyncElement( $element, "checkbox", ( props ) => {
        instance.$props.props.value = props.value
        instance.$props.props.error = props.error
        instance.$props.props.disabled = props.disabled                    
      })
    })
    return true
  },

  createCombobox( $parent ) {
    this.queryComponent($parent, ".combobox[data-component='combobox'], #gotopage", ( el ) => {
      const $element = $(el)
      const $label = $("label[for=" + $element.attr("id") + "]")
      const instance = this.createComponent(el, "combobox", "combobox-component", ( component ) => {
        component.props.value = this.getValue($element)
        component.props.items = this.getOptionsArray($element)
        component.props.multiple = $element.is("[multiple]")

        // Update Label to point to new Vue Element (if there is a matching label)
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)

          if ( component.props.displayStyle === 'list' && component.props.multiple ) {
            $label.append('<span class="combobox-label-count">(' + component.props.value.length + ')</span>');
          }
        }

        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val( value ).trigger("change")

          if ( component.props.displayStyle === 'list' && component.props.multiple ) {
            $label.find(".combobox-label-count").text("(" + value.length + ")");
          }
        }

        return component
      })

      this.addDomSyncElement( $element, "combobox", ( props ) => {
        instance.$props.props.value = props.value
        instance.$props.props.error = props.error
        instance.$props.props.disabled = props.disabled
        instance.$props.props.items = props.items
      })
    })

    return true
  },
  
  createTimePicker( $parent ) {
    this.queryComponent($parent, ".time[data-component='timepicker']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "timepicker", "timepicker-component", ( component ) => {
        component.props.value = this.getValue($element)        
        
        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${component.id}_label`)       
        }

        // Change event to update base element with value changes
        component.events.change = ( value ) => {
          $element.val( value ).trigger("change")
        }

        return component
      })

      this.addDomSyncElement( $element, ( props ) => {
        instance.$props.props.value = props.value
        instance.$props.props.error = props.error
        instance.$props.props.disabled = props.disabled                   
        instance.$props.props.minTime = props.minTime
        instance.$props.props.maxTime = props.maxTime
        instance.$props.props.step = props.step
      })
    })
    return true    
  },

  createOverlay( ) {
    if ($("#nextgen-overlay").length > 0) {
      return;
    }

    const $overlay = $('<div id="nextgen-overlay"></div>').appendTo("body");

    this.createComponent($overlay[0], "overlay", "overlay-component");
  },

  createComponent( el, componentType, componentName, fnUpdateProps ) {
    const vm_id = this.getVmId( el )
    const Constructor = Vue.extend(LegacyWrapperComponent)

    let component = {
      id: vm_id,
      type: componentName,
      props: {},
      events: {}
    }

    // Add properties that start with "data-<componentType>" as props to Vue instance
    component.props = this.getElementProps( $(el), componentType )

    // Update properties
    if ( typeof fnUpdateProps === "function" ) {
      component = fnUpdateProps( component ) 
    }

    // Create Vue Instance
    const instance = new Constructor({
      propsData: component
    })
    
    // Hide the existing element and create container for the Vue element
    if (vm_id !== "menu-button")
      $(el).addClass("vue-component").hide().after(`<div id="${vm_id}"></div>`)

    // Mount the Vue instance in the container
    instance.$mount(`#${vm_id}`)   

    // Return instance
    return instance 
  },

  queryComponent( $parent, selector, fn ) {
    $(selector, $parent).not(".vue-component").each((i, el) => {
      if ( typeof fn === "function" ) {
        fn(el)
      }      
    })
  },

  getVmId( el ) {
    if (el.id === "menu-button")
      return "menu-button"
      
    this.vm_id += 1
    return (el.id || el.tagName).toLowerCase() + "_vm_" + this.vm_id
  },  

  getValue( $el ) {
    if ( !App.isjQuery($el) ) {
      return null
    }

    let value = $el.val()
    if ( $el.is("select") ) {
      if ( !value ) {
        return []
      } else if ( Array.isArray(value) ) {
        return value
      }
      return [ value ]
    }
    else if ( $el.is("input[type=checkbox]") ) {
      return $el.prop("checked")
    }

    return value
  },

  getOptionsArray( $el ) {
    const options = []
    if ( !App.isjQuery($el) || !$el.is("select") ) {
      return []
    }    
    
    $el.find("option").each((i, opt) => {
      const $option = $(opt)
      options.push({
        value: $option.val(),
        label: $option.text()
      })
    })

    return options
  },

  getElementProps( $el, componentType, data ) {
    if ( !App.isjQuery($el) ) {
      return {}
    }

    let props = Object.assign({}, data)

    props.value = this.getValue($el)
    props.items = this.getOptionsArray($el)
    props.disabled = $el.is("[disabled]")
    props.error = $el.is(".error")

    for (let attr of $el[0].attributes) {      
      if ( attr.name.startsWith("data-" + componentType) ) {
        const name = converToCamelCase(attr.name.replace("data-" + componentType + "-", ""))  
        try {
          props[name] = JSON.parse(attr.value)
        } catch (err) {
          props[name] = attr.value
        }
      }
    }  

    return props
  },

  addDomSyncElement( $el, componentType, fn ) {
    if ( !App.isjQuery($el) ) {
      return false
    }

    this.domSyncElements.push({
      element: $el,
      syncFunction: fn,
      componentType: componentType,
      props: this.getElementProps( $el, componentType, {})
    })
  },

  initializeDomSync(  ) {
    clearInterval(this.domSyncEvent)

    // This interval is to sync DOM values to a Vue component
    this.domSyncEvent = setInterval(() => {

      const valueChanged = ( v1, v2 ) => {
        if ( typeof v1 !== typeof v2 ) return true
        if ( typeof v1 === "boolean" && v1 !== v2 ) return true
        if ( typeof v1 === "string" && v1 !== v2 ) return true
        if ( typeof v1 === "number" && v1 !== v2 ) return true
        if ( Array.isArray(v1) && JSON.stringify(v1) !== JSON.stringify(v2) ) return true
        return false
      }
 
      this.domSyncElements.forEach( o => {
        let changes = false
        const currentProps = this.getElementProps( o.element, o.componentType, o.props )
        
        Object.keys(currentProps).forEach( k => {
          if ( valueChanged(currentProps[k], o.props[k]) ) {
            changes = true
          }
        })

        // Changes were found so run sync function
        if ( changes && typeof o.syncFunction === "function" ) {
          //console.log("domSync", o.componentType, o.props, currentProps)
          o.syncFunction( currentProps )
        }

        o.props = currentProps
      })
    }, 10)

    return true
  },

  showMenu( show ) {
    if ( typeof show === "boolean" && show ) {
      $("body").addClass("menu--state-open");
    } else {
      $("body").removeClass("menu--state-open");
    }
  },
  
}